/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskViolentCrimeDetail
 */
export interface ExecRiskViolentCrimeDetail {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskViolentCrimeDetail
     */
    assault_index?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskViolentCrimeDetail
     */
    murder_index?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskViolentCrimeDetail
     */
    rape_index?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskViolentCrimeDetail
     */
    robbery_index?: number;
}

/**
 * Check if a given object implements the ExecRiskViolentCrimeDetail interface.
 */
export function instanceOfExecRiskViolentCrimeDetail(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskViolentCrimeDetailFromJSON(json: any): ExecRiskViolentCrimeDetail {
    return ExecRiskViolentCrimeDetailFromJSONTyped(json, false);
}

export function ExecRiskViolentCrimeDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskViolentCrimeDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assault_index': !exists(json, 'assault_index') ? undefined : json['assault_index'],
        'murder_index': !exists(json, 'murder_index') ? undefined : json['murder_index'],
        'rape_index': !exists(json, 'rape_index') ? undefined : json['rape_index'],
        'robbery_index': !exists(json, 'robbery_index') ? undefined : json['robbery_index'],
    };
}

export function ExecRiskViolentCrimeDetailToJSON(value?: ExecRiskViolentCrimeDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'assault_index': value.assault_index,
        'murder_index': value.murder_index,
        'rape_index': value.rape_index,
        'robbery_index': value.robbery_index,
    };
}

